<template>
  <div class="container-fluid navigation-bar p-1 px-2">
    <button @click="toggle" class="burger">
      <font-awesome-icon icon="fa-solid fa-bars" />
    </button>

    <div class="navbar-logo"></div>
    <div class="navigation-box">
    </div>
    <div class="user-settings my-2">
      <button @click="syncData" class="burger">
        <font-awesome-icon icon="fa-solid fa-arrows-rotate" />
      </button>
    </div>
  </div>
</template>
<script>

export default {
  name: "NavigationBar",
  async created() {
  },
  data() {
    return {
    };
  },
  props: {
    toggle: {
      type: Function,
      require: true,
    },
  },
  methods: {
    syncData() {
      return window.location.reload(true);
    },

  }
};
</script>
<style lang="scss" scoped>
.counter {
  position: absolute;
  top: 0;
  left: 0;
  background-color: red;
  color: white;
  border-radius: 50%;
  padding: 2px 6px;
  font-size: 0.75rem;
  font-weight: bold;
}
.bell-container {
  color: white;
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
}

.burger {
  background: transparent;
  color: white;
  font-size: 30px;
  border: none;
}

.user-settings {
  display: flex;
  flex-direction: row;
  justify-content: end;
}

button.btn {
  margin: 5px;
}

.red-blinking {
  color: red;
  animation: blinker 1.5s linear infinite;
}

@keyframes blinker {
  50% {
    opacity: 0;
  }
}


.navigation-bar {
  display: flex;
  background: #1d90dd;
  justify-content: space-around;
  align-items: center;
  min-height: 58px;
  max-height: 60px;
  height: 5vh;

  .navbar-logo {
    width: 100px;
    height: 50px;
    flex: 1;
  }

  .navigation-box {
    flex: 2;
  }


  .toastr {
    z-index: 1060;
  }

  .user-settings {
    flex: 1;
  }
}

.navigation-route-view {
  flex: 1;
  max-height: 96vh;
}
</style>
